<template>
  <div :class="`container page page-${routeName} ${$route.meta?.newPage ? 'page-new' : ''}`">
    <el-container class="layout pageContainer">
      <!-- 侧边栏 -->
      <Sidebar class="layout-aside" />
      <el-container class="layout-container">
        <!-- 顶部组件 -->
        <el-header class="layout-header">
          <HeaderComponent v-if="hasPostAgentFinally" :callerWindowState="callerWindowState" :lusUserCti="lusUserCti" />
        </el-header>
        <!-- 菜单导航 -->
        <TagsView class="layout-main-header layout-tagsView"/>
        <!-- 主内容容器 -->
        <el-main class="layout-main">
          <el-main class="layout-main-container container mainContainer">
            <transition name="fade">
              <keep-alive :include="cacheRouteNames">
                <router-view ></router-view>
              </keep-alive>
            </transition>
          </el-main>
        </el-main>
      </el-container>
    </el-container>

    <!-- 弹窗：响铃 -->
    <ModalIncomeCall
      v-if="callerWindowState.showInComingDrawer"
      :initData="callerWindowState"
      draggable
      @refuse="callerWindowState.refuse"
      @sipLink="callerWindowState.sipLink" />
    <!--   自动拨打木块 -->
    <ModalAutoDial />
    <!-- 弹窗：通话中 -->
    <ModalCalling
      v-if="!callerWindowState.showInComingDrawer && callerWindowState.callWindowStatus && callerWindowState.callWindowStatus !== 'ON_WAITING'"
      :initData="callerWindowState"
      draggable
      :isCallOut="onRingingParams.isCallOut"
      :callWindowStatus="callerWindowState.callWindowStatus"
      @onRatingHangupe="onRatingHangupe" />
    
    <!-- 用于播放客户接通的敲门声 -->
    <audio id="huawuDoor" preload src="https://static-rc.heiniubao.com/files/door.mp3?v20240918"></audio>
  </div>
</template>
<script>
import Sidebar from "@/layout/components/Sidebar/index.vue";
import HeaderComponent from "@/layout/components/HeaderComponent/index.vue";
import TagsView from "@/layout/components/TagsView/index.vue";
import ModalIncomeCall from '@/layout/components/ModalIncomeCall/index.vue';
import ModalCalling from '@/layout/components/ModalCalling/index.vue';
import ModalAutoDial from '@/layout/components/ModalAutoDial/index.vue';

import { mapState } from "vuex";
import { callerWindowState } from "@/utils/helper/caller.window.state";

export default {
  name: "WisdomCloudHome",
  components: {
    HeaderComponent,
    Sidebar,
    ModalIncomeCall,
    ModalCalling,
    ModalAutoDial,
    TagsView,
  },
  data() {
    return {
      callerWindowState,
      hasPostAgentFinally: false,  //是否已请求坐席详情接口完成
    };
  },
  computed: {
    ...mapState('global', ['lusUserCti']),
    ...mapState('tagsView', ['cacheRouteNames']),
    routeName(){return this.$route.name;},
    onRingingParams(){return this.callerWindowState.onRingingParams},
  },
  mounted() {
    this.queryAgent();
  },
  methods: {
    queryAgent(){
      let userInfo = localStorage.getItem('userInfo');
      if (!userInfo) return;
      userInfo = JSON.parse(userInfo);
      this.$store.dispatch('global/getLusUserCti', {userId: userInfo.id}).then(data => {
        if (!(data && data.cno)) return;
      }).finally(() => {
        this.hasPostAgentFinally = true;
      });
    },
    // 回拨挂断评分
    onRatingHangupe(){
      const { onRingingParams } = this;
      const callId = onRingingParams.mainUniqueId || onRingingParams.instanceId;
      this.$store.dispatch('fs/ratingHangupe', {callId}).then(res => {
        if (res && res.code === '000000'){
          this.callerWindowState.hangup();
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
